module.exports = __webpack_public_path__ + "img/1147028343.1680f6db.jpg";